const businessSectors = [ 
  {
    title: 'Aeroespacial / Aeronáutico / Naval',
    id: 'BS00',
    index: 1,
    color: '#e87c36',
    parents: ['ES01', 'ES02'],
    colorFilterValues: {
      invert: '59',
      sepia: '26',
      saturate: '1886',
      hueRotate: '337',
      brightness: '95',
      contrast: '90'
    }
  },
  {
    title: 'Agroalimentario / Mundo Agrario / Agro Industrial',
    id: 'BS01',
    index: 2,
    color: '#e87c36',
    parents: ['ES00'],
    colorFilterValues: {
      invert: '59',
      sepia: '26',
      saturate: '1886',
      hueRotate: '337',
      brightness: '95',
      contrast: '90'
    }
  },
  {
    title: 'Industrial diversificadas multisectoriales',
    id: 'BS40',
    index: 3,
    color: '#e87c36',
    parents: ['ES01'],
    colorFilterValues: {
      invert: '59',
      sepia: '26',
      saturate: '1886',
      hueRotate: '337',
      brightness: '95',
      contrast: '90'
    }
  },
  {
    title: 'Bienes de Equipo',
    id: 'BS03',
    index: 4,
    color: '#e87c36',
    parents: ['ES01', 'ES02'],
    colorFilterValues: {
      invert: '59',
      sepia: '26',
      saturate: '1886',
      hueRotate: '337',
      brightness: '95',
      contrast: '90'
    }
  },
  {
    title: 'Bioquímico / Químico',
    id: 'BS04',
    index: 5,
    color: '#e87c36',
    parents: ['ES01'],
    colorFilterValues: {
      invert: '59',
      sepia: '26',
      saturate: '1886',
      hueRotate: '337',
      brightness: '95',
      contrast: '90'
    }
  },
  {
    title: 'Sector Construcción / Ingeniería',
    id: 'BS05',
    index: 6,
    color: '#e87c36',
    parents: ['ES01', 'ES02'],
    colorFilterValues: {
      invert: '59',
      sepia: '26',
      saturate: '1886',
      hueRotate: '337',
      brightness: '95',
      contrast: '90'
    }
  },
  {
    title: 'Real Estate Inmo',
    id: 'BS06',
    index: 7,
    color: '#e87c36',
    parents: ['ES01', 'ES02'],
    colorFilterValues: {
      invert: '59',
      sepia: '26',
      saturate: '1886',
      hueRotate: '337',
      brightness: '95',
      contrast: '90'
    }
  },
  {
    title: 'Obra públicas / Infraestructuras',
    id: 'BS07',
    index: 8,
    color: '#e87c36',
    parents: ['ES03'],
    colorFilterValues: {
      invert: '59',
      sepia: '26',
      saturate: '1886',
      hueRotate: '337',
      brightness: '95',
      contrast: '90'
    }
  },
  {
    title: 'Cosmético / Lujo',
    id: 'BS08',
    index: 9,
    color: '#e87c36',
    parents: ['ES01', 'ES02'],
    colorFilterValues: {
      invert: '59',
      sepia: '26',
      saturate: '1886',
      hueRotate: '337',
      brightness: '95',
      contrast: '90'
    }
  },
  {
    title: 'Energía',
    id: 'BS09',
    index: 10,
    color: '#e87c36',
    parents: ['ES01', 'ES02', 'ES03'],
    colorFilterValues: {
      invert: '59',
      sepia: '26',
      saturate: '1886',
      hueRotate: '337',
      brightness: '95',
      contrast: '90'
    }
  },
  {
    title: 'Farmacéutico',
    id: 'BS10',
    index: 11,
    color: '#e87c36',
    parents: ['ES01'],
    colorFilterValues: {
      invert: '59',
      sepia: '26',
      saturate: '1886',
      hueRotate: '337',
      brightness: '95',
      contrast: '90'
    }
  },
  {
    title: 'Internet / Telecomunicaciones',
    id: 'BS11',
    index: 12,
    color: '#e87c36',
    parents: ['ES02', 'ES03'],
    colorFilterValues: {
      invert: '59',
      sepia: '26',
      saturate: '1886',
      hueRotate: '337',
      brightness: '95',
      contrast: '90'
    }
  },
  {
    title: 'Materias Primas / Minero',
    id: 'BS12',
    index: 13,
    color: '#e87c36',
    parents: ['ES00'],
    colorFilterValues: {
      invert: '59',
      sepia: '26',
      saturate: '1886',
      hueRotate: '337',
      brightness: '95',
      contrast: '90'
    }
  },
  {
    title: 'Médico / Hospitalario / Servicios profesionales',
    id: 'BS13',
    index: 14,
    color: '#e87c36',
    parents: ['ES02', 'ES03', 'ES04', 'ES05'],
    colorFilterValues: {
      invert: '59',
      sepia: '26',
      saturate: '1886',
      hueRotate: '337',
      brightness: '95',
      contrast: '90'
    }
  },
  {
    title: 'Software / Hardware / Electrónico',
    id: 'BS14',
    index: 15,
    color: '#e87c36',
    parents: ['ES01'],
    colorFilterValues: {
      invert: '59',
      sepia: '26',
      saturate: '1886',
      hueRotate: '337',
      brightness: '95',
      contrast: '90'
    }
  },
  {
    title: 'Telecomunicaciones',
    id: 'BS15',
    index: 16,
    color: '#e87c36',
    parents: ['ES02', 'ES03', 'ES04'],
    colorFilterValues: {
      invert: '59',
      sepia: '26',
      saturate: '1886',
      hueRotate: '337',
      brightness: '95',
      contrast: '90'
    }
  },
  {
    title: 'Sector Téxtil',
    id: 'BS16',
    index: 17,
    color: '#e87c36',
    parents: ['ES01'],
    colorFilterValues: {
      invert: '59',
      sepia: '26',
      saturate: '1886',
      hueRotate: '337',
      brightness: '95',
      contrast: '90'
    }
  },
  {
    title: 'Sector Turístico',
    id: 'BS17',
    index: 18,
    color: '#e87c36',
    parents: ['ES02'],
    colorFilterValues: {
      invert: '59',
      sepia: '26',
      saturate: '1886',
      hueRotate: '337',
      brightness: '95',
      contrast: '90'
    }
  },
  {
    title: 'Sector Biotecnologías',
    id: 'BS18',
    index: 19,
    color: '#e87c36',
    parents: ['ES01', 'ES04'],
    colorFilterValues: {
      invert: '59',
      sepia: '26',
      saturate: '1886',
      hueRotate: '337',
      brightness: '95',
      contrast: '90'
    }
  },
  {
    title: 'Sector Público / Corporaciones Estatales',
    id: 'BS19',
    index: 20,
    color: '#e87c36',
    parents: ['ES03'],
    colorFilterValues: {
      invert: '59',
      sepia: '26',
      saturate: '1886',
      hueRotate: '337',
      brightness: '95',
      contrast: '90'
    }
  },
  {
    title: 'Sector Bancario Local',
    id: 'BS20',
    index: 21,
    color: '#e87c36',
    parents: ['ES02', 'ES03'],
    colorFilterValues: {
      invert: '59',
      sepia: '26',
      saturate: '1886',
      hueRotate: '337',
      brightness: '95',
      contrast: '90'
    }
  },
  {
    title: 'Tercer Sector / Instituciones sin ánimo de lucro',
    id: 'BS21',
    index: 22,
    color: '#e87c36',
    parents: ['ES05'],
    colorFilterValues: {
      invert: '59',
      sepia: '26',
      saturate: '1886',
      hueRotate: '337',
      brightness: '95',
      contrast: '90'
    }
  },
  {
    title: 'Silvicultura sostenible',
    id: 'BS23',
    index: 23,
    color: '#e87c36',
    parents: ['ES00'],
    colorFilterValues: {
      invert: '59',
      sepia: '26',
      saturate: '1886',
      hueRotate: '337',
      brightness: '95',
      contrast: '90'
    }
  },
  {
    title: 'Investigación y desarrollo',
    id: 'BS28',
    index: 24,
    color: '#e87c36',
    parents: ['ES04'],
    colorFilterValues: {
      invert: '59',
      sepia: '26',
      saturate: '1886',
      hueRotate: '337',
      brightness: '95',
      contrast: '90'
    }
  },
  {
    title: 'Seguridad',
    id: 'BS30',
    index: 25,
    color: '#e87c36',
    parents: ['ES05'],
    colorFilterValues: {
      invert: '59',
      sepia: '26',
      saturate: '1886',
      hueRotate: '337',
      brightness: '95',
      contrast: '90'
    }
  },
  {
    title: 'Cultura',
    id: 'BS31',
    index: 26,
    color: '#e87c36',
    parents: ['ES05'],
    colorFilterValues: {
      invert: '59',
      sepia: '26',
      saturate: '1886',
      hueRotate: '337',
      brightness: '95',
      contrast: '90'
    }
  },
  {
    title: 'Comercio financiero',
    id: 'BS32',
    index: 27,
    color: '#e87c36',
    parents: ['ES02', 'ES04'],
    colorFilterValues: {
      invert: '59',
      sepia: '26',
      saturate: '1886',
      hueRotate: '337',
      brightness: '95',
      contrast: '90'
    }
  },
  {
    title: 'Banca corporativa e institucional',
    id: 'BS33',
    index: 28,
    color: '#e87c36',
    parents: ['ES02'],
    colorFilterValues: {
      invert: '59',
      sepia: '26',
      saturate: '1886',
      hueRotate: '337',
      brightness: '95',
      contrast: '90'
    }
  },
  {
    title: 'Franquiciamiento',
    id: 'BS34',
    index: 29,
    color: '#e87c36',
    parents: ['ES02'],
    colorFilterValues: {
      invert: '59',
      sepia: '26',
      saturate: '1886',
      hueRotate: '337',
      brightness: '95',
      contrast: '90'
    }
  },
  {
    title: 'Fabricación y manufacturas',
    id: 'BS35',
    index: 30,
    color: '#e87c36',
    parents: ['ES01'],
    colorFilterValues: {
      invert: '59',
      sepia: '26',
      saturate: '1886',
      hueRotate: '337',
      brightness: '95',
      contrast: '90'
    }
  },
  {
    title: 'Educación, academias, escuelas independientes.',
    id: 'BS37',
    index: 31,
    color: '#e87c36',
    parents: ['ES02', 'ES03', 'ES04', 'ES05'],
    colorFilterValues: {
      invert: '59',
      sepia: '26',
      saturate: '1886',
      hueRotate: '337',
      brightness: '95',
      contrast: '90'
    }
  },
  {
    title: 'Bienes de consumo',
    id: 'BS38',
    index: 32,
    color: '#e87c36',
    parents: ['ES02'],
    colorFilterValues: {
      invert: '59',
      sepia: '26',
      saturate: '1886',
      hueRotate: '337',
      brightness: '95',
      contrast: '90'
    }
  },
  {
    title: 'Socios Sociales',
    id: 'BS39',
    index: 33,
    color: '#e87c36',
    parents: [''],
    colorFilterValues: {
      invert: '59',
      sepia: '26',
      saturate: '1886',
      hueRotate: '337',
      brightness: '95',
      contrast: '90'
    }
  },
  {
    title: 'Otros',
    id: 'BS22',
    index: 34,
    color: '#e87c36',
    parents: ['ES00', 'ES01', 'ES02', 'ES03', 'ES04', 'ES05'],
    colorFilterValues: {
      invert: '59',
      sepia: '26',
      saturate: '1886',
      hueRotate: '337',
      brightness: '95',
      contrast: '90'
    }
  }
]
export default businessSectors
